import { useEffect, useRef, useState } from "react";

// Type-to-search officer picker — replaces a long <select> dropdown.
// Typing filters officers by name or mobile number; click a match to pick.
// `value` is the officer id (string); `onChange` receives the id string.
export default function OfficerSelect({ officers, value, onChange }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  // Close the suggestion list when clicking outside.
  useEffect(() => {
    const onDocClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const label = (o) =>
    o.full_name + (o.mobile ? ` · 📱 ${o.mobile}` : "");

  const selected = officers.find((o) => String(o.id) === String(value));
  if (selected) {
    return (
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <span
          style={{
            flex: 1,
            padding: "8px 10px",
            border: "1px solid #ddd",
            borderRadius: 4,
            background: "#f6f8fa",
          }}
        >
          {label(selected)}
        </span>
        <button
          type="button"
          className="btn btn-sm"
          onClick={() => {
            onChange("");
            setQuery("");
            setOpen(true);
          }}
        >
          Change
        </button>
      </div>
    );
  }

  const q = query.trim().toLowerCase();
  const matches = (
    q
      ? officers.filter(
          (o) =>
            (o.full_name || "").toLowerCase().includes(q) ||
            (o.mobile || "").includes(query.trim())
        )
      : officers
  ).slice(0, 8);

  return (
    <div ref={boxRef} style={{ position: "relative" }}>
      <input
        placeholder="Search officer by name or mobile…"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 50,
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 4,
            marginTop: 2,
            maxHeight: 220,
            overflowY: "auto",
            boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          }}
        >
          {matches.length === 0 ? (
            <div className="muted" style={{ padding: "8px 10px", fontSize: 13 }}>
              No officers found.
            </div>
          ) : (
            matches.map((o) => (
              <div
                key={o.id}
                onClick={() => {
                  onChange(String(o.id));
                  setOpen(false);
                  setQuery("");
                }}
                style={{
                  padding: "8px 10px",
                  cursor: "pointer",
                  fontSize: 13,
                  borderBottom: "1px solid #f0f0f0",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f4f8")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
              >
                {label(o)}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
